export default __webpack_public_path__ + "1cbd3b774cd2d467f845903949a0a493.png";